import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CoreModule } from "@core/core.module";
import { DuiCoreModule, DuiCardModule, DuiValidationErrorModule } from "@databank-ui";
import { SharedModule } from "@shared/shared.module";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginComponent } from "./login.component";

@NgModule({
    declarations: [LoginComponent],
    imports: [
        CoreModule,
        SharedModule,
        LoginRoutingModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DuiCardModule,
        DuiValidationErrorModule,
        DuiCoreModule,
    ],
    providers: [],
    exports: [LoginComponent],
})
export class LoginModule {}
